module.exports = __webpack_public_path__ + "static/media/info_grey.0305ac6b.svg";